import { API_AUTH } from "./common";

const CauHinhTaiSanApi = {
  SelectByPage: ({
    sTenHangHoa,
    sStatus,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `CauHinhTaiSan/SelectByPage?sTenHangHoa=${sTenHangHoa}&sStatus=${sStatus}&PageIndex=${pageIndex}&PageSize=${pageSize}`,
      {}
    ),
  deleteCauHinh: ({ id }) =>
    API_AUTH.get(`CauHinhTaiSan/DeleteByID?id=${id}`, {}),
  changeStatus: ({ id, currentStatus }) =>
    API_AUTH.get(`CauHinhTaiSan/ChangStatusById?id=${id}&currentStatus=${currentStatus}`, {}),
  addorupdate: (data) => API_AUTH.post(`CauHinhTaiSan/AddOrUpdate`, data),
  checkNewCode: ({id,mahanghoa}) => API_AUTH.get(`CauHinhTaiSan/CheckNewCode?id=${id}&mahanghoa=${mahanghoa}`, {}),
  SelectCauHinhGiamTruTaiSanByCauHinhTaiSanId:({
    CauHinhTaiSanId,
    hangSanXuatId,
    DongSanPhamId,
    NamSanXuat
  })=> API_AUTH.get(`CauHinhTaiSan/SelectCauHinhGiamTruTaiSanByCauHinhTaiSanId?CauHinhTaiSanId=${CauHinhTaiSanId}&hangSanXuatId=${hangSanXuatId}&DongSanPhamId=${DongSanPhamId}&NamSanXuat=${NamSanXuat}`,{}),
  AddOrUpdateCauHinhGiamTru: (data)=> API_AUTH.post(`CauHinhTaiSan/AddOrUpdateCauHinhGiamTruTaiSan`,data),
  DeleteCauHinhGiamTruTaiSanByID: ({id})=> API_AUTH.post(`CauHinhTaiSan/DeleteCauHinhGiamTruTaiSanByID?CauHinhGiamTruTaiSanID=${id}`),
  GetThuocTinhTaiSanByCauHinhTaiSanId: ({id})=>API_AUTH.get(`CauHinhTaiSan/GetThuocTinhTaiSanByCauHinhTaiSanId?CauHinhTaiSanId=${id}`)
};

export default CauHinhTaiSanApi;
